import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import BookingSection from './components/BookingSection';
import DemoLinksSection from './components/DemoLinksSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans selection:bg-brand-100 selection:text-brand-900">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <BookingSection />
        <DemoLinksSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;